import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchHighlightPipeModule } from '@y42/core/search-highlight';
import { IntercomModule } from '@y42/intercom';
import { GoJsSearchNodeFilterPipe } from './gojs-search-node-filter.pipe';
import { GoJsSearchNodeComponent } from './gojs-search-node.component';

@NgModule({
  imports: [
    CommonModule,
    IntercomModule,
    FontAwesomeModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatListModule,
    SearchHighlightPipeModule,
  ],
  declarations: [GoJsSearchNodeComponent, GoJsSearchNodeFilterPipe],
  exports: [GoJsSearchNodeComponent],
})
export class GoJsSearchNodeModule {}
